import { TipoDeAcao } from './tipo-de-acao.model';

export class NaturezaDeAcao {

  Id: number;
  Descricao: string;
  TipoDeAcaoId: number;
  PerguntasPadroes: string;
  ValorPadraoPorcentualCliente: number;
  ValorPardaoPorcentualEscritorio: number;
  Ativo: boolean;
  TipoDeAcao: TipoDeAcao;

  constructor() {
    this.Id = 0;
    this.ValorPadraoPorcentualCliente = 0;
    this.ValorPardaoPorcentualEscritorio = 0;
    this.TipoDeAcao = new TipoDeAcao();
  }
}

export class NaturezaDeAcaoPesquisa {

  Id: number;
  Descricao: string;
  TipoDeAcao: string;
  Ativo: boolean;

  constructor() {
    this.Id = 0;
    this.Descricao = '';
    this.TipoDeAcao = '';
  }
}
